module.exports = __webpack_public_path__ + "static/media/003.8bd48008.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/003.jpg
// module id = 1578
// module chunks = 0